import { render, staticRenderFns } from "./vendorAttachDetail.vue?vue&type=template&id=31dea88f"
import script from "./vendorAttachDetail.vue?vue&type=script&lang=js"
export * from "./vendorAttachDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31dea88f')) {
      api.createRecord('31dea88f', component.options)
    } else {
      api.reload('31dea88f', component.options)
    }
    module.hot.accept("./vendorAttachDetail.vue?vue&type=template&id=31dea88f", function () {
      api.rerender('31dea88f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorAttachDetail.vue"
export default component.exports